import { IParsedChartDataFunnel } from '../interfaces';
import { IFunnelDataKeysPerLine } from '../FunnelChart/dataKeysUtils';

export enum TooltipContextType {
  DEFAULT,
  FUNNEL_CONVERSION,
  FUNNEL_CONVERSION_SINGLE,
  FUNNEL_FREQUENCY,
  FUNNEL_TIME_TO_CONVERT,
}

export interface IDefaultTooltipContext {
  type: TooltipContextType.DEFAULT;
}

export interface IFunnelConversionTooltipContext {
  type: TooltipContextType.FUNNEL_CONVERSION;
  dataKeysPerLine: IFunnelDataKeysPerLine;
}

export interface ISingleFunnelConversionTooltipContext {
  type: TooltipContextType.FUNNEL_CONVERSION_SINGLE;
  dataKeysPerLine: IFunnelDataKeysPerLine;
}

export interface IFunnelFrequencyTooltipContext {
  type: TooltipContextType.FUNNEL_FREQUENCY;
  measureControls: IParsedChartDataFunnel['measureControls'];
  dataKeysPerLine: IFunnelDataKeysPerLine;
}

export interface IFunnelTimeToConvertTooltipContext {
  type: TooltipContextType.FUNNEL_TIME_TO_CONVERT;
  measureControls: IParsedChartDataFunnel['measureControls'];
  dataKeysPerLine: IFunnelDataKeysPerLine;
}

export const DEFAULT_TOOLTIP_CONTEXT: ITooltipContext = {
  type: TooltipContextType.DEFAULT,
};

export type ITooltipContext =
  | IDefaultTooltipContext
  | ISingleFunnelConversionTooltipContext
  | IFunnelConversionTooltipContext
  | IFunnelFrequencyTooltipContext
  | IFunnelTimeToConvertTooltipContext;
